import React, { Component } from "react";
import { connect } from "react-redux";
import {
  GLOBAL_PROJECT_TYPE_CHAMBER,
} from "../../lib/types";
import {
  Dialog,
  DialogFooter,
  DialogType
} from "office-ui-fabric-react/lib-commonjs/Dialog";
import {
  PrimaryButton,
  DefaultButton
} from "office-ui-fabric-react/lib-commonjs/Button";
import {
  submitAccept,
  submitReject,
  closeDialog,
  buildProjectAutomation,
  buildPipeProjectAutomation
} from "../../actions/submit-dialog-actions";
import {
  scaleStage,
  positionStage
} from "../../actions/viewport-actions";
import { setCurrentSubProject } from "../../actions/sub-project-actions";
import { restoreSubProjectPersistedState } from "../../actions/sub-project-crud-actions";
import { clearMainManifoldsState } from "../../actions/manifold-actions";
import "./index.css";
import ProjectSelectors from "../../reducers/project-reducer";

class SubmitDialog extends Component {
  handleDialogClose(proceed) {
    if (proceed) {
      /* build project and invoke action */
      this.zoom()
        .then(() => {
          this.props.submitAccept(this.props);
        });
    } else {
      this.props.submitReject();
    }
  }
  async zoom() {
    this.props.scaleStage(1.0, 1.0);
    this.props.positionStage(0.0, 0.0);
  }

  bedHasActiveComponents() {
    /* if bridge is present, communicate with serialized project */
    if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
      if (!this.props.isMultiBedProject) {
        let rows = this.props.chamberRows;
        return rows.some(r => r.getActiveCount() > 0);
      } else {
        for (let i = 0; i < this.props.multiBed.beds.length; i++) {
          if (!this.props.multiBed.beds[i].chambers)
            return false;
        }
      }
    }
    return true;
  }

  render() {
    const {
      lang,
      content
    } = this.props;

    /* if there are active rows */
    if (this.bedHasActiveComponents()) {
      return (
        <Dialog
          hidden={this.props.hidden}
          onDismiss={() => this.handleDialogClose(false)}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].submitProject,
            subText: content[lang].doYouWantToSubmit
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <DialogFooter>
            <PrimaryButton
              onClick={() => this.handleDialogClose(true)}
              text={content[lang].yes}
            />
            <DefaultButton
                onClick={() => this.handleDialogClose(false)}
                text={content[lang].cancel}
                className={"outline_grey_ads"}
            />
          </DialogFooter>
        </Dialog>
      );
    } else {
      return (
        <Dialog
          hidden={this.props.hidden}
          onDismiss={() => this.handleDialogClose(false)}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].emptyChamberBed,
            subText: this.props.isMultiBedProject
              ? content[lang].multiBedPleaseAddChambersToYourProject
              : content[lang].pleaseAddChambersToYourProject
          }}
          modalProps={{
            isBlocking: false
          }}
        >
          <DialogFooter>
            <PrimaryButton
              text={content[lang].ok}
              onClick={() => this.handleDialogClose(false)}
            />
          </DialogFooter>
        </Dialog>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,
    /* this component properties */
    stage: window.konvaStage,
    hidden: state.submitdialog.hidden,
    project: state.submitdialog.project,
    scaleValue: state.globals.scaleValue,
    chamberType: state.globals.chamberType,
    scalePixels: state.globals.scalePixels,
    projectType: state.globals.projectType,
    chamberEndCapType: state.globals.chamberEndCapType,
    chamberRowSpacing: state.globals.chamberRowSpacing,
    /* chamber bed properties */
    chamberBedX: state.chamberbed.x,
    chamberBedY: state.chamberbed.y,
    chamberBedWidth: state.chamberbed.width,
    chamberBedScaleX: state.chamberbed.scaleX,
    chamberBedScaleY: state.chamberbed.scaleY,
    chamberRows: state.chamberbed.chamberRows,
    chamberBedHeight: state.chamberbed.height,
    chamberBedRotation: state.chamberbed.rotation,
    hasCornerOutlet: state.chamberbed.hasCornerOutlet,
    /* the calculations values to be serialized */
    underdrain: state.calculations.underdrain,
    porosityPercent: state.calculations.porosityPercent,
    porousStoneAbove: state.calculations.porousStoneAbove,
    porousStoneBelow: state.calculations.porousStoneBelow,
    totalStorageProvided: state.calculations.totalStorageProvided,
    /* multi-bed support */
    multiBed: state.multiBed,
    resourcesTokens: state.authentication.resourcesTokens,
    user: state.authentication.user,
    isMultiBedProject: ProjectSelectors.isMultiBedProject(),

  };
};

const mapDispatchToProps = {
  submitAccept,
  submitReject,
  closeDialog,
  scaleStage,
  positionStage,
  setCurrentSubProject,
  clearMainManifoldsState,
  restoreSubProjectPersistedState,
  buildPipeProjectAutomation,
  buildProjectAutomation
};

/* export this contained component */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitDialog);



// WEBPACK FOOTER //
// ./src/components/submitDialog/index.js